import React, { useEffect, useState } from "react";
import styles from "./DocumentHistory.module.scss";
import add_member from "assets/icons/add_member.png";
import bucket from "assets/icons/delete.svg";

import userInfo from "utils/userInfo";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import { Button } from 'components';
import Notification from "utils/Notifications";
import { useDispatch } from "react-redux";
import AgreementCard from "./AgreementHistory/AgreementCard";
import ApprovalSelect from "./components/ApprovalSelect";
import MemberSelect from "./components/MemberSelect";
import { setSignStatement } from "store/slices/StatementsSlice";
import { SignRaport, SignRaportFile, getHistoryOrder, getHistorystatement } from "service/StatementsService";
import { useParams } from "react-router-dom";
import { patchOrder, patchOrderFormData } from "service/OrderService";
import { setPatchedOrder } from "store/slices/OrderSlice";
import { AddWaterMark } from "hooks/PdfWaterMark/AddWaterMark";
import PinCode from "hooks/PinCode/PinCode";
import { ScaleLoader } from "react-spinners";
import eyeIcon from "../../assets/icons/team-check-alt.svg"
import eyeIcon1 from "../../assets/icons/eye.png"
import documentIcon from "../../assets/icons/time-past.svg"
import { height, style } from "@mui/system";
import DivisionSelect from "./components/DivisionSelect";
import { type } from "@testing-library/user-event/dist/type";
import chatIcon from "../../assets/icons/chatss.png"
import ChatPage2 from "pages/ChatPage2/ChatPage2";
import {
  checkPinCode,
} from "service/AuthService";

const DocumentHistory = ({ typeDoc, info, setRender, history, handleClickDecline, handleClickDecline1, handleClickReSend1, setState, handleClickAcquainted, handleClickReSend, handleChange, AcquaintedStatement1, text, chats }) => {

  const user = userInfo();
  const [report, setReport] = useState();

  const [userPinCode, setUserPinCode] = useState();
  const [userId, setUserId] = useState();
  const [pinOrComment, setPinOrComment] = useState(true)
  const [pinCode, setPinCode] = useState();
  const [load, setLoad] = useState(false)

  const [comment, setComment] = useState();

  const [idMember, setIdMember] = useState({
    id: "",
    member: "",
    member_queue: "",
    member_choose_action: "",
  });
  const [openModal, setOpenModal] = useState(false);
  const [approvalId, setApprovalId] = useState({
    approval_name: "",
    approval_id: "",
  });
  const [divisionId, setDivisionId] = useState({
    division_name: "",
    division_id: "",
  });
  const [memberInfo, setMemberInfo] = useState([]);
  const [memberArray, setMemberArray] = useState([]);
  const [order_count, setOrderCount] = useState(1);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [loader, setLoader] = useState(false);
  const [soglosov, setSoglosov] = useState(true);
  const [chatOrder, setChatOrder] = useState(false);
  const [urgently,seturgently] = useState(false)
  const [historyview, sethistoryView] = useState(false);
  const [familiarization, setFamiliarization] = useState(false);
  const [render1, setRender1] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const dispatch = useDispatch();





  const AddMember = async () => {
    setLoad(true)
    memberArray.map((item) => delete item.id);

    if (typeDoc === "Рапорт") {
      let newMember = {
        addressee: info.addressee,
        status: info.status,
        agreement_comment: comment,
        applicationmember: memberArray,
        very_urgent : urgently
      };
      let response = await SignRaport(info.id, newMember);

      dispatch(setSignStatement(response.data));
    }

    setOpenModal2(false);
    setNotify({
      isOpen: true,
      message: "Участники успешно добавлены",
      type: "success", sound: "success"
    });
    setLoad(false)

  };


  const AddMembersforfamiliarization = async () => {
    setLoad(true)
    memberArray.map((item) => delete item.id);

    if (typeDoc === "Рапорт") {
      let newMember = {
        addressee: info.addressee,
        status: "На ознакомлении",
        agreement_comment: comment,
        division: divisionId.division_id,
        type_approval: 6,
        members: memberArray
      };
      let response = await SignRaport(info.id, newMember);

      // dispatch(setSignStatement(response.data));
    }

    setOpenModal3(false);
    setNotify({
      isOpen: true,
      message: "Участники успешно добавлены",
      type: "success", sound: "success"
    });
    setLoad(false)
  };

  const AddMembersforfamiliarizationOrder = async () => {
    setLoad(true)
    memberArray.map((item) => delete item.id);


    let newMember = {
      addressee: info.addressee,
      status: "На ознакомлении",
      agreement_comment: comment,
      division: divisionId.division_id,
      type_approval: 6,
      members: memberArray
      
    };
    let response = await patchOrder(info.id, newMember);

    // dispatch(setSignStatement(response.data));


    setOpenModal3(false);
    setNotify({
      isOpen: true,
      message: "Участники успешно добавлены",
      type: "success", sound: "success"
    });
    setLoad(false)
  };

  const FinalRaportAccept = async () => {
    const updatedAppMember = [
      {
        id: idMember.id,
        member: idMember.employeeId,
        user: idMember.member,
        user_id: idMember.member,
        member_queue: idMember.member_queue,
        member_refusal: report,
        status: "Одобрено",
      },
    ];

    // if (report === undefined) {
    //   setNotify({
    //     isOpen: true,
    //     message: " Введите причину отказа!",
    //     type: "error",
    //   });
    // } else {
    if (typeDoc === "Рапорт") {
      setLoader(true);
      const member = info.applicationmember.find((item) => item.turn === true);
      const count_turn = member ? member.member_queue + 1 : null;
      const file = info?.file;
      const name = member ? member.short_name : null;

      const type_approv = member ? member.name_approval : null;
      const type =
        type_approv === "Одобрить"
          ? "Одобрено"
          : type_approv === "Согласовать"
            ? "Согласовано"
            : type_approv === "Ознакомиться"
              ? "Ознакомлено"
              : type_approv === "Утвердить"
                ? "Утверждено"
                : type_approv === "Резолюция"
                  ? "Принято"
                  : "";



      const modifedFile = await AddWaterMark({
        name: user.lastName ? `${user.surName}.${user.firstName?.split('')[0]}.${user.lastName?.split('')[0]}` : `${user.surName}.${user.firstName?.split('')[0]}`,
        type,
        count_turn,
        file,
      });

      let SignStatement = {
        addressee: info.addressee,
        status: info.status,
        applicationmember: updatedAppMember,
      };

      let SignStatementFile = {
        addressee: info.addressee,
        status: info.status,
        file: modifedFile,
      };

      let response = await SignRaport(info.id, SignStatement);

      let response2 = await SignRaportFile(info.id, SignStatementFile);

      setRender(true)
      setLoader(false)
      dispatch(setSignStatement(response.data));
    } else if (typeDoc === "Приказ") {
      try {
        setLoader(true);
        const member = info.ordermember.find((item) => item.turn === true);
        const count_turn = member ? member.member_queue : null;
        const file = info?.file;
        const name = member ? member.short_name : null;

        const type_approv = member ? member.name_approval : null;
        const type =
          type_approv === "Одобрить"
            ? "Одобрено"
            : type_approv === "Согласовать"
              ? "Согласовано"
              : type_approv === "Ознакомиться"
                ? "Ознакомлено"
                : type_approv === "Утвердить"
                  ? "Утверждено"
                  : type_approv === "Резолюция"
                    ? "Принято"
                    : "";



        const modifedFile = await AddWaterMark({
          name: user.lastName ? `${user.surName}.${user.firstName?.split('')[0]}.${user.lastName?.split('')[0]}` : `${user.surName}.${user.firstName?.split('')[0]}`,

          type,
          count_turn,
          file,
        });

        let SignStatement = {
          addressee: info.addressee,
          status: info.status,
          ordermember: updatedAppMember,
        };
        let SignStatementFile = {
          addressee: info.addressee,
          status: info.status,
          file: modifedFile,
        };
        let response = await patchOrder(info.id, SignStatement);
        let response2 = await patchOrderFormData(info.id, SignStatementFile);

        dispatch(setPatchedOrder(response.data));
        dispatch(setPatchedOrder(response2.data));
      } catch (error) {
        console.log("CHU");
      } finally {
        setLoader(false);
      }
    }

    setNotify({
      isOpen: true,
      message: "Отчет успешно отправлен!",
      type: "success", sound: "success"
    });
    setOpenModal(false);

  };

  const FinalRaportDecline = async () => {
    const updatedAppMember = [
      {
        id: idMember.id,
        member: idMember.employeeId,
        user: idMember.member,
        user_id: idMember.member,
        member_queue: idMember.member_queue,
        member_refusal: report,
        status: "Отказано",
      },
    ];

    if (report === undefined) {
      setNotify({
        isOpen: true,
        message: " Введите причину отказа!",
        type: "error",
      });
    } else {
      if (typeDoc === "Рапорт") {
        let SignStatement = {
          addressee: info.addressee,
          status: info.status,
          applicationmember: updatedAppMember,
        };
        let response = await SignRaport(info.id, SignStatement);

        dispatch(setSignStatement(response.data));
      } else if (typeDoc === "Приказ") {
        let SignStatement = {
          addressee: info.addressee,
          status: info.status,
          ordermember: updatedAppMember,
        };

        let response = await patchOrder(info.id, SignStatement);

        dispatch(setPatchedOrder(response.data));
      }


      setLoader(true);
      setTimeout(() => {
        setLoader(false);
        setOpenModal(false);
        setNotify({
          isOpen: true,
          message: "Отчет успешно отправлен!",
          type: "success", sound: "success"
        });
      }, 1000);
    }
  };

  const RetryRaport = async () => {
    const updatedAppMember = [
      {
        id: idMember.id,
        member: idMember.employeeId,
        user: idMember.member,
        user_id: idMember.member,
        member_queue: idMember.member_queue,
        repeat_comment: report,
        status: "На рассмотрении",
        turn: true,
      },
    ];

    if (report === undefined) {
      setNotify({
        isOpen: true,
        message: " Введите причину отказа!",
        type: "error",
      });
    } else {
      if (typeDoc === "Рапорт") {
        let SignStatement = {
          addressee: info.addressee,
          status: info.status,
          applicationmember: updatedAppMember,
        };
        let response = await SignRaport(info.id, SignStatement);

        dispatch(setSignStatement(response.data));
      } else if (typeDoc === "Приказ") {
        let SignStatement = {
          addressee: info.addressee,
          status: info.status,
          ordermember: updatedAppMember,
        };

        let response = await patchOrder(info.id, SignStatement);

        dispatch(setPatchedOrder(response.data));
      }
      setNotify({
        isOpen: true,
        message: "Отчет успешно отправлен!",
        type: "success", sound: "success"
      });
      setOpenModal(false);
    }
  };

  const deleteElement = (id) => {
    // удаление объекта из массива при совпадении id
    setMemberInfo(memberInfo.filter((obj) => obj.id != id));
    setMemberArray(memberArray.filter((obj) => obj.id != id));
    setOrderCount(order_count - 1);
  };
  let sortedArray;
  typeDoc === "Заявление"
    ? (sortedArray =
      info?.statementmember &&
      [...info.statementmember].sort(
        (a, b) => a.member_queue - b.member_queue
      ))
    : typeDoc === "Приказ"
      ? (sortedArray =
        info?.ordermember &&
        [...info.ordermember].sort((a, b) => a.member_queue - b.member_queue))
      : (sortedArray =
        info?.applicationmember &&
        [...info.applicationmember].sort(
          (a, b) => a.member_queue - b.member_queue

        )


      );



 const pinLogIn = async () => {
  if (String(pinCode).length !== 4) {
    setNotify({
      isOpen: true,
      message: "Введите 4-значный ПИН-код",
      type: "error",
    });
    return;
  }

  try {
    const response = await checkPinCode(pinCode, user.userId); // user.id - id пользователя

    if (response.data.success) {
      setNotify({
        isOpen: true,
        message: "Верный Пин-Код!",
        type: "success",
        sound: "success",
      });
      setPinOrComment(false);
    } else {
      setNotify({
        isOpen: true,
        message: "Неправильный Пин-Код",
        type: "error",
      });
    }
  } catch (error) {
    setNotify({
      isOpen: true,
      message: "Ошибка сервера. Попробуйте позже.",
      type: "error",
    });
  }
};

  const hanldeSoglosov = () => {
    setSoglosov(true)
    sethistoryView(false)
    setFamiliarization(false)
    setChatOrder(false)
  }

  const handleHistorywiew = () => {
    setSoglosov(false)
    sethistoryView(true)
    setChatOrder(false)
    setFamiliarization(false)
  }

  const handleFamilizir = () => {
    setSoglosov(false)
    sethistoryView(false)
    setChatOrder(false)
    setFamiliarization(true)
  }

  const handleChatView = () => {
    setSoglosov(false)
    sethistoryView(false)
    setChatOrder(true)
    setFamiliarization(false)
  }

  const toggleUrgently = () => {
    seturgently(!urgently);
  };

  if (typeDoc === 'Рапорт' && familiarization === true || typeDoc === 'Приказ' && familiarization === true) {
    sortedArray = sortedArray?.filter((item) => item?.name_approval === 'На ознакомлении')
  } else {
    sortedArray = sortedArray?.filter((item) => item?.name_approval !== 'На ознакомлении')
  }


  const familizarionOne = info?.applicationmember?.filter((elem) => {
    return elem?.user === user.userId;
  });


  return (
    <div className={styles.history_wrapper}>
      <div className={styles.history_header}>
        <h3>Отправитель</h3>
        <div className={styles.personal_info}>
          <div className={styles.user_avatar}>
            <img
              src={info?.employee?.imeag}
              alt="avatar"
              // onClick={handleClickImg}
              style={{ cursor: "pointer" }}
              className={styles.user_avatar_img}
            />{" "}
          </div>
          <div className={styles.user_name}>
            <span>
              {info?.employee?.first_name} {info?.employee?.surname}
            </span>
            <br />

            <span style={{ color: "#525C69B3", fontSize: "13px" }}>
              {info?.employee?.number_phone}
            </span>
            <br />
            <span style={{ color: "#525C69B3", fontSize: "13px" }}>
              {info?.employee?.division}
            </span>
            <br />
            <span style={{ color: "#525C69B3", fontSize: "13px" }}>
              {info?.employee?.position}
            </span>
          </div>

          {/* <div className={styles.user_online}>online</div> */}
        </div>
      </div>
      <div className={styles.history_header}>
        <h3>Подписант</h3>
        <div className={styles.personal_info}>
          <div className={styles.user_avatar}>
            <img
              src={info?.photo}
              alt="avatar"
              // onClick={handleClickImg}
              style={{ cursor: "pointer" }}
              className={styles.user_avatar_img}
            />{" "}
          </div>
          <div className={styles.user_name}>
            <span>
              {info?.prorector}
            </span>
            <br />

            <span style={{ color: "#525C69B3", fontSize: "13px" }}>
              {info?.number_addressee}
            </span>
            <br />
            <span style={{ color: "#525C69B3", fontSize: "13px" }}>
              {info?.division}
            </span>
            <br />
            <span style={{ color: "#525C69B3", fontSize: "13px" }}>
              {info?.position}
            </span>
          </div>

          {/* <div className={styles.user_online}>online</div> */}
        </div>
      </div>


      <div className={styles.history_body}>
        {info.agreement_comment === null ? (
          ""
        ) : (
          <>
            {" "}
            Комментарий от {info.prorector_name}:
            <h3>{info.agreement_comment}</h3>{" "}
          </>
        )}

        {typeDoc !== "Приказ" ? user.employeeId === info.employee?.id &&
          (info.status === "В режиме ожидания" ||
            info.status === "В процессе выполнения") ? (
          <div className={styles.btns_rightside}>
            <Button disabled="true" className={styles.btn3}>
              {" "}
              {/* Успешно отправлено{" "} */}
            </Button>
          </div>
        ) : info.user_id_prorector === user.userId &&
          info.status !== "Отказано" &&
          info.status !== "Завершена" &&
          info.status !== "В канцелярии" &&
          info.status !== "Ознакомлен" &&
          info.applicationmember?.some(
            (item) => item.status === "На рассмотрении"
          ) === false &&
          info.has_tasks === false ? (
          <div>
            <div className={styles.btns_rightside}>
              <Button
                className={styles.btn4}
                onClick={handleClickDecline}
              >
                {" "}
                Доработать
              </Button>

              <Button
                className={styles.btn2}
                onClick={handleChange
                }
              >
                Формировать задачу
              </Button>
              {/* <Button
                        className={styles.btn2}
                        onClick={handleClickСhancellery}
                      >
                        {" "}
                        Подписать и на концелярию
                      </Button> */}
              <Button
                className={styles.btn2}
                onClick={handleClickAcquainted}
              >
                {" "}
                Ознакомлен
              </Button>
              {/* <Button
                className={styles.btn2}
                onClick={handleClickReSend}
              >
                {" "}
                Передать
              </Button> */}
            </div>
          </div>
        ) : (
          ""
        ) : info.employee === user.employeeId &&
          (info.status === "В режиме ожидания" ||
            info.status === "В процессе выполнения") ? (
          <div className={styles.btns_rightside}>
            <Button disabled="true" className={styles.btn3}>
              {" "}
              Успешно отправлено{" "}
            </Button>
          </div>
        ) : info?.addressee === user.employeeId &&
          info.status !== "Отказано" &&
          info.status !== "На регистрацию" &&
          info.status !== "Зарегистрировано" &&
          info.status !== "Ознакомлен" ? (
          <div>
            <div className={styles.btns_rightside}>
              <Button
                className={styles.btn_pin_close}
                onClick={handleClickDecline1}
                style={{ marginTop: "20px" }}
              >
                {" "}
                Доработать
              </Button>

              {/* <Button
                        className={styles.btn2}
                        onClick={() =>
                          setState({ isPaneOpen: true, isTask: true })
                        }
                      >
                        Формировать задачу на основе Приказа
                      </Button> */}
              {/* <Button
                        className={styles.btn2}
                        onClick={handleClickСhancellery}
                      >
                        {" "}
                        Подписать и на концелярию
                      </Button> */}
              <Button
                className={styles.btn2}
                onClick={AcquaintedStatement1}
              >
                {" "}
                Подписать
              </Button>
              {/* <Button
                className={styles.btn2}
                onClick={handleClickReSend1}
              >
                {" "}
                Передать
              </Button> */}
            </div>
          </div>
        ) : (
          ""
        )}
        {typeDoc === "Документ" ? (
          info.prorector === undefined ? (
            ""
          ) : info.user_id_prorector === user.userId &&
            info.documentmember?.length === 0 &&
            info.status !== "В канцелярии" &&
            info.status !== "Ознакомлен" &&
            info.status !== "Отказано" &&
            info.status !== "Завершена"
            ? (

              <button
                src={add_member}
                title="Добавить участников"
                onClick={() => setOpenModal2(true)}
                className={styles.size3}
                alt=""
              >На резолюцию</button>
            ) : (
              ""
            )
        ) : (
          ""
        )}
        {typeDoc === "Заявление" ? (
          info.prorector === undefined ? (
            ""
          ) : info?.prorector?.includes(user.surName) &&
            info?.statementmember?.length === 0 &&
            info.status !== "В канцелярии" &&
            info.status !== "Ознакомлен" &&
            info.status !== "Отказано" &&
            info.status !== "Завершена"
            ? (
              <button
                src={add_member}
                title="Добавить участников"
                onClick={() => setOpenModal2(true)}
                className={styles.size3}
                alt=""
              >На резолюцию</button>
            ) : (
              ""
            )
        ) : (
          ""
        )}
        {typeDoc === "Рапорт" ? (
          info.prorector === undefined ? (
            ""
          ) : info?.prorector?.includes(user.surName) &&
            info.user_id_prorector === user.userId &&
            info?.applicationmember?.length === 0 &&
            info.status !== "В канцелярии" &&
            info.status !== "Ознакомлен" &&
            info.status !== "Отказано" &&
            info.status !== "Завершена"
            ? (
              <button
                src={add_member}
                title="Добавить участников"
                onClick={() => setOpenModal2(true)}
                className={styles.size3}
                alt=""
              >На резолюцию</button>
            ) : (
              ""
            )
        ) : (
          ""
        )}
        { info?.employee?.user === user.userId ?  (
    <button
          style={{marginTop: '0'}}
        className={styles.size3}
        onClick={() => setOpenModal3(true)}
    >
        Отправить на ознакомление
    </button>
) : null}


        {familizarionOne?.length !== 0 && familizarionOne?.name_approval == "На ознакомлении" ? (<button
          className={styles.btn2}
          onClick={handleChange
          }
          style={{ padding: '5px 7px', border: 'none', margin: '10px' }}
        >
          Формировать задачу
        </button>) : null}


        <div className={styles.menu_preview}>
          <button
            style={soglosov ? { backgroundColor: 'white' } : null}
            onClick={hanldeSoglosov}
            className={styles.menu_btn}
          >
            <img style={{ width: '20px' }} src={eyeIcon} alt="" />
          </button>
          <button
            onClick={handleHistorywiew}
            style={{ backgroundColor: historyview ? 'white' : undefined }}
            className={styles.menu_btn}
          >
            <img style={{ width: '20px' }} src={documentIcon} alt="" />
          </button>
          <button
            onClick={handleFamilizir}
            style={{ backgroundColor: familiarization ? 'white' : undefined }}
            className={styles.menu_btn}
          >
            <img style={{ width: '20px' }} src={eyeIcon1} alt="" />
          </button>

          {/* <button
            onClick={handleChatView}
            style={{ backgroundColor: chatOrder ? 'white' : undefined }}
            className={styles.menu_btn}
          >
            <img style={{  width: '20px',color: 'black' }} src={chatIcon} alt="" />
          </button> */}

        </div>
        {/* <div style={{display: 'flex', gap: '10px',}}>
          <button onClick={() => setSoglosov(false)}>Согласование</button>
          <button onClick={() => setSoglosov(true)}>История</button>

          </div> */}

        <div className={styles.history_body_header}>
          {soglosov ? (<h4>Участники</h4>) : null}
          {historyview ? (<h4>История</h4>) : null}
          {chatOrder ? (<h4>Чат {typeDoc}</h4>) : null}
          {familiarization ? (<h4>Список ознакомления</h4>) : null}




        </div>
        {soglosov ? (<>
          <div style={{ height: '550px', overflowY: 'auto' }}>

            {info?.applicationmember?.length === 0 ? "Список участников пуст" : ""}
            {info?.statementmember?.length === 0 ? "Список участников пуст" : ""}
            {sortedArray?.map((item) => (
              <AgreementCard
                user={user}
                setOpenModal={setOpenModal}
                item={item}
                setIdMember={setIdMember}
                prorector={info.prorector}
                info={info}
              />
            ))}

          </div>
        </>) : null}

        {historyview ? (
          <div className={styles.table}>

            {history.length !== 0 ? history.history?.map((item, index) => (<>
              <div key={user.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <div style={{ width: '30px', height: '30px', borderRadius: '6px', border: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '10px', backgroundColor: '#5800FF', color: 'white' }}>
                  {index + 1}
                </div>

                <div  className={styles.tableTitleInfo}>
                  <p className={styles.tableTitle}>{item?.text}</p>

                  <p className={styles.tableDate}>{item?.created_at}</p>
                </div></div></>)) : null}
          </div>) : null}

        {familiarization ? (<>
          <div style={{ height: '550px', overflowY: 'auto' }}>
            {info?.applicationmember?.length === 0 ? "Список пуст" : ""}
            {info?.statementmember?.length === 0 ? "Список пуст" : ""}
            {sortedArray?.map((item) => (
              <AgreementCard
                user={user}
                setOpenModal={setOpenModal}
                item={item}
                setIdMember={setIdMember}
                prorector={info.prorector}
                info={info}
              />
            ))}
          </div>
        </>
        ) : null}
{chatOrder ? (<>
          <ChatPage2 typeDoc = {typeDoc} id={info.id} setRender = {setRender} chats = {chats}/>
        </>
        ) : null}
      </div>

      {pinOrComment ? (<ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalText={"Введите ПИН-код"}
      >
        <>
          <PinCode setPinCode={setPinCode} passwordVisible={false} />

          <Button
            onClick={() => setOpenModal(false)}
            className={styles.btn_pin_close}
            id={styles.closeBtn}
          >
            {" "}
            Закрыть
          </Button>

          {idMember.member_choose_action === "Одобрено" ? (<>
            {loader ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <ScaleLoader color="grey" size={30} />
              </div>
            ) : (
              <Button onClick={FinalRaportAccept} className={styles.btn_pin}>
                Подписать
              </Button>
            )}
          </>) : (<Button id={styles.pinBtn} onClick={pinLogIn} className={styles.btn_pin}>
            Подтвердить
          </Button>)}


        </>
      </ModalWindow>) : (<ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalTitle={"Введите комментарий"}
      >
        <div className={styles.decline_form}>
          <div className={styles.item_flex1}>
            <div className={styles.input_type3}>
              <textarea
                onChange={(e) => setReport(e.target.value)}
                className={styles.discription_input}
                placeholder="Описание"
                required
              />
            </div>
          </div>
        </div>
        {/* <PinCode setPinCode={setPinCode} passwordVisible={false} /> */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ maxHeight: '50px' }}>

            <Button
              onClick={() => { setOpenModal(false); setPinOrComment(true) }}
              className={styles.btn_pin_close}
            >
              Закрыть
            </Button>
          </div>

          {idMember.member_choose_action === "Отказано" ? (
            <>

              {loader ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <ScaleLoader color="grey" size={30} />
                </div>
              ) : (
                <Button onClick={FinalRaportDecline} className={styles.btn_pin}>
                  Доработать
                </Button>
              )}
            </>

          ) : idMember.member_choose_action === "На рассмотрении" ? (
            <Button onClick={RetryRaport} className={styles.btn_pin}>
              Отправить повторно
            </Button>
          ) : (
            <>
              {loader ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <ScaleLoader color="grey" size={30} />
                </div>
              ) : (
                <Button onClick={FinalRaportAccept} className={styles.btn_pin}>
                  Подписать
                </Button>
              )}
            </>
          )}
        </div>
      </ModalWindow>)}



      <ModalWindow
        openModal={openModal2}
        setOpenModal={setOpenModal2}
        modalTitle={"Добавьте участников для согласования"}
      >
         <div style={{display: 'flex', justifyContent: 'end', alignItems: 'center',gap: '3px'}}>
            <span>Весьма срочно </span>
            <input  style={{ cursor: 'pointer', marginRight: '5px' }} onChange={toggleUrgently} checked={urgently} type="checkbox" name="" id="" />
          </div>
        <div className={styles.decline_form}>
          {memberArray.length === 9 ? <div style={{ paddingBottom: '15px' }}>Достигнут лимит согласования</div> : <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className={styles.item_flex}>
              <ApprovalSelect setApprovalId={setApprovalId} />
              <MemberSelect
                order_count={order_count}
                setOrderCount={setOrderCount}
                approvalId={approvalId}
                memberInfo={memberInfo}
                setMemberInfo={setMemberInfo}
                setMemberArray={setMemberArray}
                memberArray={memberArray}
              />
            </div>
          </div>}

          <h3>Выбранные согласующие</h3>
          {memberInfo === undefined
            ? []
            : memberInfo.map((item, index) => {
              return (
                <div key={item.id} className={styles.flex}>
                  <h4>
                    {index + 1} {item.type_approval} : {item.member}{" "}
                  </h4>

                  <img
                    onClick={() => deleteElement(item.id)}
                    className={styles.size}
                    src={bucket}
                    alt=""
                  />
                </div>
              );
            })}
          <textarea
            onChange={(e) => setComment(e.target.value)}
            className={styles.discription_input}
            placeholder="Комментарий участникам согласования"
            required
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ maxHeight: '50px', marginTop: '14px' }}>

            <Button
              onClick={() => setOpenModal2(false)}
              className={styles.btn_pin_close}
            >
              Закрыть
            </Button>
          </div>

          {load ? <ScaleLoader color="grey" size={30} /> : <Button onClick={AddMember} className={styles.btn_pin}>
            Сохранить
          </Button>}
        </div>


      </ModalWindow>



      <ModalWindow
        openModal={openModal3}
        setOpenModal={setOpenModal3}
        modalTitle={"Добавьте участников для ознакомления"}
      >
        <div className={styles.decline_form}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginTop: '10px' }} className={styles.item_flex}>

              {/* <h3>Выберите отдел</h3>
              <DivisionSelect setDivisionId={setDivisionId} /> */}
              <h3>Выберите  сотрудника</h3>

              <MemberSelect
                order_count={order_count}
                setOrderCount={setOrderCount}
                approvalId={approvalId}
                memberInfo={memberInfo}
                setMemberInfo={setMemberInfo}
                setMemberArray={setMemberArray}
                memberArray={memberArray}
              />
            </div>
          </div>

          <h3>Выбранные для ознакомления</h3> 
          {memberInfo === undefined
            ? []
            : 
             
            memberInfo.map((item, index) => {
              return (
                <div key={item.id} className={styles.flex}>
                  <h4>
                    {index + 1} {item.type_approval} : {item.member}{" "}
                  </h4>

                  <img
                    onClick={() => deleteElement(item.id)}
                    className={styles.size}
                    src={bucket}
                    alt=""
                  />
                </div>
              );
            })}
          <textarea
            onChange={(e) => setComment(e.target.value)}
            className={styles.discription_input}
            placeholder="Комментарий участникам ознакомления"
            required
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ maxHeight: '50px', marginTop: '14px' }}>

            <Button
              onClick={() => setOpenModal3
                (false)}
              className={styles.btn_pin_close}
            >
              Закрыть
            </Button>
          </div>

          {load ? <ScaleLoader color="grey" size={30} /> :
            typeDoc == 'Приказ' ? (
              <Button onClick={AddMembersforfamiliarizationOrder} className={styles.btn_pin}>
                Сохранить
              </Button>) : (<Button onClick={AddMembersforfamiliarization} className={styles.btn_pin}>
                Сохранить
              </Button>)}
        </div>


      </ModalWindow>


      <Notification notify={notify} setNotify={setNotify} />
    </div>

  );
};

export default DocumentHistory;
